import { render, staticRenderFns } from "./tourist.vue?vue&type=template&id=f6e30bfc&scoped=true"
import script from "./tourist.vue?vue&type=script&lang=js"
export * from "./tourist.vue?vue&type=script&lang=js"
import style0 from "./tourist.vue?vue&type=style&index=0&id=f6e30bfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e30bfc",
  null
  
)

export default component.exports